import React from 'react'

export default ({image, imageMobile}) => {
  if (!image && !imageMobile) return null

  return (
    <div>
      <div 
        className={`${imageMobile ? 'hidden md:block' : ''} w-full bg-cover bg-center h-[350px] lg:h-[500px]`}
        style={{backgroundImage: `url('${image}')`}}
      >
      </div>
      {
        imageMobile && 
        <div
          className="block md:hidden w-full bg-cover bg-center h-[250px]"
          style={{backgroundImage: `url('${imageMobile}')`}}
        >
        </div>
      }
    </div>
  )
}